module.exports = __webpack_public_path__ + "img/mx.c83597df.svg";